import { getCalApi } from '@calcom/embed-react';

// Cal.com booking config — change CAL_LINK to 'syedmaazsaeeddev/15min' for the 15-min event.
export const CAL_LINK = 'syedmaazsaeeddev/30-min-meeting';
export const CAL_NAMESPACE = '30min';
export const CAL_CONFIG = '{"layout":"month_view","theme":"dark"}';

// Initialise the Cal popup, themed to match the site.
// Safe to call from multiple components — Cal handles this as a singleton.
export const initCalPopup = async () => {
  const cal = await getCalApi({ namespace: CAL_NAMESPACE });
  cal('ui', {
    theme: 'dark',
    cssVarsPerTheme: { dark: { 'cal-brand': '#4db5ff' } },
    hideEventTypeDetails: false,
    layout: 'month_view',
  });
};
